import React, { useMemo } from 'react'
import { useNotificationContext } from '../../../../../../context/notification/context'
import { ButtonPrimaryConfirm, ButtonPrimaryDelay } from '../../../../../../shared/component/button'
import { IconDelete, IconEmail } from '../../../../../../shared/icon/icon'
import { FleetSection } from '../../../../../../shared/sso-workspace/fleet-page'
import { dateText } from '../../../../../../shared/date/local-time'
import { useApiFormUserInvite } from '../../../../../../api-new/state/content'

const labels = { pending: 'Pending', accepted: 'Accepted', revoked: 'Revoked', expired: 'Expired', declined: 'Declined', member: 'Member, invitation open' }

export const inviteStatusLabel = status => labels[status] || ''

const day = value => (value ? dateText(value) : '')

// An invite's status and expiry, with resend (a NEW key -- the old link stops
// working) and revoke. Both address the invited user row; the key itself is
// never shown or copyable (owner direction 2026-09-27). An accepted invite
// has nothing to do: the person page's Details say when it was accepted
// (owner 2026-10-29: the page's cards are the house's sections, with the
// actions in the header).
export const UserInvite = ({ userLogin, onUpdate }) => {
  const apiFormUserInvite = useApiFormUserInvite()

  const notificationContext = useNotificationContext()

  const status = userLogin.inviteStatus

  const canResend = ['pending', 'expired', 'revoked', 'declined', 'member'].includes(status)
  const canRevoke = status === 'pending' || status === 'member'

  const expiresLabel = useMemo(() => (status === 'expired' ? 'expired' : 'expires'), [status])

  const handleResend = async () => {
    await apiFormUserInvite.put(`user/${userLogin.userID}/resend`)
    notificationContext.toast.notify('Invite email sent', 3000)
    onUpdate && onUpdate()
  }

  // A member whose invitation is still open (their organization's sign-in
  // already made them a member): withdrawing it drops only what it would
  // add; they stay a member (re-review 6 RM6-3).
  const member = status === 'member'

  const handleRevoke = async () => {
    await apiFormUserInvite.put(`user/${userLogin.userID}/revoke`)
    notificationContext.toast.notify(member ? 'Invitation withdrawn' : 'Invite revoked', 3000)
    onUpdate && onUpdate()
  }

  if (!status || status === 'accepted') {
    return null
  }

  return (
    <FleetSection
      id="pp-invite"
      title="Invitation"
      actions={(canResend || canRevoke) &&
        <React.Fragment>
          {canResend && <ButtonPrimaryDelay Icon={IconEmail} text="re-send invite email" small onClick={handleResend} />}
          {canRevoke &&
            <ButtonPrimaryConfirm
              Icon={IconDelete}
              text={member ? 'Withdraw invitation (they stay a member)' : 'revoke invite'}
              small
              confirmText={
                member
                  ? "Withdraw this invitation? Its link stops working and what it would add isn't given. They stay a member of this organization. You can send a new one later."
                  : 'Revoke this invitation? Its link stops working. You can send a new one later.'
              }
              onConfirm={handleRevoke}
            />}
        </React.Fragment>}>
      <dl className="sw-dl pp-dl">
        <dt>Status</dt>
        <dd>{inviteStatusLabel(status)}</dd>
        <dt>Invited</dt>
        <dd>{day(userLogin.inviteInvitedAt)}</dd>
        <dt className="text-capitalize">{expiresLabel}</dt>
        <dd>{day(userLogin.inviteExpiresAt)}</dd>
      </dl>
    </FleetSection>
  )
}
